import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export type LegalPageType = 'PRIVACY' | 'COOKIE' | 'TERMS' | 'REGULATION';

export interface EffectiveLegalPage {
  type: LegalPageType;
  title: string;
  body: string;
  badge: string;
  /** 0 = contenuto di default (codice); >0 = salvato dal backoffice. */
  version: number;
  lastUpdated: string;
  source: 'db' | 'default';
  updatedAt: string | null;
}

export interface UpsertLegalPageInput {
  title: string;
  body: string;
}

const QK = {
  list: ['legal-pages'] as const,
  one: (type: LegalPageType) => ['legal-pages', type] as const,
};

export function useLegalPages() {
  return useQuery({
    queryKey: QK.list,
    queryFn: async () => {
      const res = await apiClient.get<EffectiveLegalPage[]>('/legal-pages');
      return res.data;
    },
  });
}

export function useUpsertLegalPage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ type, input }: { type: LegalPageType; input: UpsertLegalPageInput }) => {
      const res = await apiClient.put<EffectiveLegalPage>(`/legal-pages/${type}`, input);
      return res.data;
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: QK.list });
      qc.invalidateQueries({ queryKey: QK.one(vars.type) });
    },
  });
}
